import MRecordingAudioPlayer from './index.vue';

MRecordingAudioPlayer.install = app => {
  app.component(MRecordingAudioPlayer.name, MRecordingAudioPlayer);
};

export default MRecordingAudioPlayer;
